export default class CustomizacaoParcelamento {
  valorEntrada: number;
  dataVencimento: Date;
}
